export const parsePartnersModelFromResponse = (response: Object) => {
  const { Models, TotalCount } = response;
  return {
    data: Models,
    totalCount: TotalCount
  };
};
